import { useEffect } from "react";
import { Modal } from 'antd';

const ProfileSetupModal = ({ message, visible, onClose }) => {
    
  useEffect(() => {
    if (visible) {
      Modal.warning({
        title: 'Alert!',
        content: (<p>{message}</p>),
        okText: 'OK',
        onOk: onClose,
      });
    }
  }, [visible, message, onClose]);

  return null;
};

export default ProfileSetupModal;
